import './EmptyState.scss'
import { memo } from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { CustomLink } from 'ui_kit_qmd'
import { SEARCH_VALUE_MIN_LENGTH } from '../Constants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
function EmptyState({ chartsSearchInputValue, loading, onClearSearch }) {
  if (loading) {
    return null
  }

  const isSearchValueValid = chartsSearchInputValue?.length >= SEARCH_VALUE_MIN_LENGTH

  return (
    <div className='charts-empty-state-container'>
      {isSearchValueValid ?
        <div>
          No results for <i>{chartsSearchInputValue}.</i>{' '}
          <CustomLink className='clear-search-link' onClick={onClearSearch}>
            Clear Search
          </CustomLink>
        </div>
      : null}

      {!isSearchValueValid && 'Please use the search option to find patients'}
    </div>
  )
}

export default memo(EmptyState)
